import React from 'react';
import { componentService } from 'js/services/component.service';

export const DepositLimits = React.lazy(() => import(/* webpackChunkName: "deposit-limits" */ './DepositLimits'));

componentService.registerPageComponents({ 'deposit-limits': DepositLimits });
